export class HttpError extends Error {
  statusCode: number;

  responseText: string | null | undefined;

  responseJson: string | null | undefined;

  errors: APIErrors | null | undefined;

  constructor(method: string, url: string, xhr: XMLHttpRequest) {
    const messageParts = [
      `Request URL: ${url}`,
      `Request method: ${method}`,
      `Status code: ${xhr.status}`,
      `Response headers: \r\n${xhr.getAllResponseHeaders()}`,
    ];

    if (xhr.responseText) {
      messageParts.push(`\r\nResponse body: \r\n${xhr.responseText}`);
    }

    super(messageParts.join('\r\n'));
    this.name = 'HTTPError';
    this.statusCode = xhr.status;

    if (xhr.responseText) {
      this.responseText = xhr.responseText;

      // @ts-expect-error TS(2531): Object is possibly 'null'.
      if (xhr.getResponseHeader('Content-Type').indexOf('json') > -1) {
        try {
          this.responseJson = JSON.parse(xhr.responseText);
          // @ts-expect-error TS(2533): Object is possibly 'null' or 'undefined'.
          this.errors = this.responseJson.errors.reduce(
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (acc: any, { description, name }: any) => {
              // eslint-disable-next-line no-param-reassign
              acc[name] = description;
              return acc;
            },
            {}
          );
        } catch (err) {}
      }
    }
  }
}
